import { render, staticRenderFns } from "./Consignor.vue?vue&type=template&id=402698f2&scoped=true"
import script from "./Consignor.vue?vue&type=script&lang=js"
export * from "./Consignor.vue?vue&type=script&lang=js"
import style0 from "./Consignor.vue?vue&type=style&index=0&id=402698f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402698f2",
  null
  
)

export default component.exports